import { render, staticRenderFns } from "./global-detail-view.vue?vue&type=template&id=0cb51084&scoped=true"
import script from "./global-detail-view.vue?vue&type=script&lang=js"
export * from "./global-detail-view.vue?vue&type=script&lang=js"
import style0 from "./global-detail-view.vue?vue&type=style&index=0&id=0cb51084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@5.2.7_prettier@2.8.7_react-dom@17.0.2_react@_xbvnx5joxenxrdtaq55cnp74na/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb51084",
  null
  
)

export default component.exports